export default __webpack_public_path__ + "static/media/1-4-5.92fb3d03.webp";